export const CURRENCY_LOCAL_STORAGE = 'currency'
export const INCOGNITO_LOCAL_STORAGE = 'incognito'
export const BANKROLL_KEY = 'bankroll'
export const TOKEN_EXP_LOCAL_STORAGE = 'tokenExpiration'
export const TOKEN_KEY_LOCAL_STORAGE = 'token'
export const TOKEN_KEY_QUERY = 'token'
export const TRACKING_KEY = 'startTime'
